import { MonthFormat, WeekdayFormat } from 'ui/common/types';

export const getMonths = (locale: string, format: MonthFormat): string[] => {
  const result = [];
  for (let m = 0; m < 12; m++) {
    result.push(new Intl.DateTimeFormat(locale, { month: format }).format(new Date(2012, m, 20, 12, 0, 0, 0)));
  }
  return result;
};

export const getWeekDays = (locale: string, format: WeekdayFormat ): string[] => {
  const result = [];  
  for (let d = 2; d < 9; d++) {
    result.push(new Intl.DateTimeFormat(locale, { weekday: format }).format(new Date(2012, 11, d, 12, 0, 0, 0)));
  }  
  return result;
};
